import { createApi } from '@reduxjs/toolkit/query/react'
import { baseApi } from './utils'
import { DamageManagerDashboardFetch, DamageManagerIndexFetch, DamageManagerSearchOptionsFetch } from '../../components/DamageManager/types'

const endDate = new Date()
const startDate = new Date()
startDate.setFullYear(startDate.getFullYear() - 2)

const historicStartDate = new Date('01/01/1990')
const historicEndDate = new Date()
historicEndDate.setFullYear(historicEndDate.getFullYear() - 2)
historicEndDate.setDate(historicEndDate.getDate() - 1)

export const damageManagerApi = createApi({
	reducerPath: 'damageManager',
	...baseApi('/damage-manager/'),
	refetchOnMountOrArgChange: true,
	tagTypes: ['OpenIndex'],
	endpoints: builder => ({
		getDashboard: builder.query<DamageManagerDashboardFetch, void>({
			query: () => 'dashboard.php',
		}),
		getNewIndex: builder.query<DamageManagerIndexFetch, void>({
			query: () =>
				'index.php?status=new&startDate=' +
				startDate.toLocaleDateString('en-GB') +
				'&endDate=' +
				endDate.toLocaleDateString('en-GB'),
		}),
		getOpenIndex: builder.query<DamageManagerIndexFetch, void>({
			query: () =>
				'index.php?status=open&startDate=' +
				startDate.toLocaleDateString('en-GB') +
				'&endDate=' +
				endDate.toLocaleDateString('en-GB'),
			providesTags: ['OpenIndex'],
		}),
		getOpenToOperatorIndex: builder.query<DamageManagerIndexFetch, void>({
			query: () =>
				'index.php?status=open to operator&startDate=' +
				startDate.toLocaleDateString('en-GB') +
				'&endDate=' +
				endDate.toLocaleDateString('en-GB'),
		}),
		getHistoricIndex: builder.query({
			query({ dashType }) {
				return `index.php?status=new,open${dashType == 'oui' ? ',open to operator' : ''}
				&startDate=${historicStartDate.toLocaleDateString('en-GB')}&endDate=${historicEndDate.toLocaleDateString('en-GB')}`
			},
		}),
		getSearchOptions: builder.query<DamageManagerSearchOptionsFetch, void>({
			query: () => 'search.php',
		}),
		getSearchIndex: builder.query({
			query: ({ signal, query }) => ({
				url: `index.php?${query}`,
				signal,
			}),
		}),
		updateDamages: builder.mutation({
			query(damages) {
				const damageIds = damages.join(':')
				const submitDamagesToClose = true
				return {
					url: 'close-damages.php',
					method: 'POST',
					body: { damageIds, submitDamagesToClose },
				}
			},
			invalidatesTags: ['OpenIndex'],
		}),
	}),
})

export const {
	useGetDashboardQuery,
	useGetNewIndexQuery,
	useGetOpenIndexQuery,
	useGetOpenToOperatorIndexQuery,
	useGetHistoricIndexQuery,
	useGetSearchOptionsQuery,
	useGetSearchIndexQuery,
	useUpdateDamagesMutation,
} = damageManagerApi
